import { FunctionalComponent, h } from 'preact';
import { useTheme } from 'styled-components';

const OffIcon: FunctionalComponent = () => {
  const theme = useTheme();

  return (
    <svg aria-hidden width="42px" height="23px" viewBox="0 0 42 23" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <g transform="translate(-86.000000, -31.000000)">
          <g transform="translate(87.000000, 32.949632)">
            <path
              d="M30.0094932,-0.5 C32.8534346,-0.5 35.4330697,0.632406246 37.3226603,2.47154687 C39.2173227,4.31562389 40.4181217,6.87029149 40.4959736,9.70631513 C40.4981622,12.7440885 39.3375699,15.4233885 37.4620437,17.3539966 C35.5609243,19.3109495 32.9241909,20.5 30.0094932,20.5 L30.0094932,20.5 L9.99050677,20.5 C7.14626154,20.5 4.56639324,19.3679366 2.67675543,17.5287725 C0.782448937,15.6850644 -0.418130086,13.1306858 -0.49597372,10.2937978 C-0.498162151,7.25597731 0.662425032,4.576654 2.53794226,2.64603293 C4.43906304,0.689056047 7.07580212,-0.5 9.99050677,-0.5 L9.99050677,-0.5 Z"
              stroke="#ffffff"
              fill={theme.ui.toggle.inactive.backgroundColor}
            />
            <path
              d="M 10 18 C 14.4183 18 18 14.4183 18 10 C 18 5.5817 14.4183 2 10 2 C 5.5817 2 2 5.5817 2 10 C 2 14.4183 5.5817 18 10 18 Z"
              fill={theme.ui.toggle.inactive.iconColor}
            />
            <path
              d="M 29.725 10.204 l 3.318 -3.315 a 0.51 0.51 0 1 0 -0.724 -0.724 L 29 9.48 l -3.319 -3.315 a 0.51 0.51 0 1 0 -0.724 0.724 l 3.318 3.315 l -3.318 3.317 a 0.51 0.51 0 1 0 0.724 0.723 L 29 10.928 l 3.319 3.317 a 0.509 0.509 0 0 0 0.724 0 c 0.2 -0.2 0.2 -0.525 0 -0.724 l -3.318 -3.317 z"
              fill={theme.ui.toggle.inactive.iconColor}
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default OffIcon;
